import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: ', 'px 0 0;\n'], ['\n  margin: ', 'px 0 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  ', ' line-height: ', 'px;\n  margin-top: 0;\n'], ['\n  ', ';\n  ', ' line-height: ', 'px;\n  margin-top: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin-left: -', 'px;\n'], ['\n  margin-left: -', 'px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ', 'px;\n'], ['\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ', 'px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  min-width: 0%;\n  flex-shrink: 1;\n  width: 100%;\n'], ['\n  min-width: 0%;\n  flex-shrink: 1;\n  width: 100%;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  white-space: nowrap;\n  padding-left: ', 'px;\n  min-width: 0%;\n  flex-shrink: 0;\n'], ['\n  white-space: nowrap;\n  padding-left: ', 'px;\n  min-width: 0%;\n  flex-shrink: 0;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  margin-bottom: ', 'px;\n'], ['\n  margin-bottom: ', 'px;\n']);

import styled, { css } from 'styled-components';
import { akTypographyMixins, akGridSizeUnitless } from '@atlaskit/util-shared-styles';

var truncationStyles = css(_templateObject);

var getTruncation = function getTruncation(_ref) {
  var truncate = _ref.truncate;
  return truncate ? truncationStyles : null;
};

export var Outer = styled.div(_templateObject2, akGridSizeUnitless * 3);

export var StyledTitle = styled.h1(_templateObject3, akTypographyMixins.h700, getTruncation, akGridSizeUnitless * 4);

export var BreadcrumbsContainer = styled.div(_templateObject4, akGridSizeUnitless / 2);

export var TitleWrapper = styled.div(_templateObject5, akGridSizeUnitless * 3);

export var TitleContainer = styled.div(_templateObject6);

export var ActionsWrapper = styled.div(_templateObject7, akGridSizeUnitless * 4);

export var BottomBarWrapper = styled.div(_templateObject8, akGridSizeUnitless * 2);